import { useMutation } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface ExportParcellingParams {
	format: 'pdf' | 'xlsx';
	maturationCycle?: 'early' | 'medium' | 'late';
	filter?: string;
	sortAsc?: boolean;
}

export function useExportParcelling() {
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({
			format,
			maturationCycle,
			filter,
			sortAsc,
		}: ExportParcellingParams) => {
			try {
				const params = new URLSearchParams();
				params.set('format', format);
				if (forBinding) params.set('forBinding', forBinding);
				if (maturationCycle) params.set('maturationCycle', maturationCycle);
				if (filter) params.set('filter', filter);
				if (sortAsc !== undefined) params.set('sortAsc', String(sortAsc));

				const response = await api.get<Blob>('/advices/parcelling/export', {
					params,
					responseType: 'blob',
				});
				const disposition = response.headers['content-disposition'] as string | undefined;
				const filename = disposition?.match(/filename="?([^";]+)"?/i)?.[1];
				return { file: response.data, filename: filename ?? `parcelamentos.${format}` };
			} catch (error) {
				throw toApiError(error, 'Erro ao exportar parcelamentos');
			}
		},
	});
}
